import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Input, Button, Alert } from '../components/design-system';
import { Mail, Lock, User, Newspaper } from 'lucide-react';

export const RegisterPage = () => {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [formData, setFormData] = useState({
    email: '', password: '', confirmPassword: '', firstName: '', lastName: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    setLoading(true);
    try {
      await register(formData.email, formData.password, formData.firstName, formData.lastName);
      navigate('/login');
    } catch (err) {
      setError(err.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  const set = (field) => (e) => setFormData({ ...formData, [field]: e.target.value });

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-accent-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-xl shadow-xl p-8">
          <div className="flex justify-center mb-6">
            <div className="h-14 w-14 bg-primary-500 rounded-xl flex items-center justify-center shadow-lg shadow-primary-200">
              <Newspaper className="h-7 w-7 text-white" />
            </div>
          </div>
          <div className="text-center mb-8">
            <h1 className="text-2xl font-bold text-gray-900 mb-1">Create Account</h1>
            <p className="text-sm text-gray-500">Join Omniapps Newsdesk</p>
          </div>

          {error && <Alert type="error" className="mb-4" onClose={() => setError('')}>{error}</Alert>}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-2 gap-3">
              <Input label="First Name" icon={User} value={formData.firstName} onChange={set('firstName')} required />
              <Input label="Last Name" value={formData.lastName} onChange={set('lastName')} required />
            </div>
            <Input label="Email" type="email" icon={Mail} value={formData.email} onChange={set('email')} required />
            <Input label="Password" type="password" icon={Lock} value={formData.password} onChange={set('password')} required />
            <Input label="Confirm Password" type="password" icon={Lock} value={formData.confirmPassword} onChange={set('confirmPassword')} required />
            <Button type="submit" className="w-full" loading={loading}>Create Account</Button>
          </form>

          <p className="mt-6 text-center text-sm text-gray-500">
            Already have an account?{' '}
            <Link to="/login" className="text-primary-600 hover:text-primary-700 font-medium">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
};
